
































import { Component, Prop, Vue } from 'vue-property-decorator';
import AppModal from '@/components/AppModal.vue';
import { mapState } from 'vuex';

@Component({
  components: { AppModal },
  computed: mapState(['modals']),
})
export default class ModalMobileMessage extends Vue {
  @Prop() public readonly show!: boolean;

  public modals: any;

  public dismissModal() {
    this.$store.dispatch('toggleModal', 'mobileMessage');
  }
}
